// All site content & asset URLs in one place.
// Brand: RSV Global Guayaquil — Ecuador (filial RSV2000 / RSVglobal).

export const ASSETS = {
  logo:    "https://customer-assets.emergentagent.com/job_pagina-web-51/artifacts/2v0a3rs7_IMG_4025.png",
  urkunde: "https://customer-assets.emergentagent.com/job_pagina-web-51/artifacts/2v0a3rs7_IMG_4025.png",
  registroOficial: "https://customer-assets.emergentagent.com/job_pagina-web-51/artifacts/7bnyxi47_813A527B-180A-45FD-8920-C94ABAB1B8F1.png",
  // Heroes / working dog photos
  marlonAction:   "https://customer-assets.emergentagent.com/job_pagina-web-51/artifacts/90zl3eh0_69f14ecb-345e-428f-baed-ab6329e05add.jpeg",
  marlonPortrait: "https://customer-assets.emergentagent.com/job_pagina-web-51/artifacts/22914hw7_4f3817dd-5b48-45fd-9bb1-09aa62a8464a.jpeg",
  jeremyFigurante:"https://customer-assets.emergentagent.com/job_pagina-web-51/artifacts/rib5kdfs_83D77A17-259B-48FA-B891-9BC64EADC1D4.png",
  workshopPoster: "https://customer-assets.emergentagent.com/job_pagina-web-51/artifacts/393spv6g_C83E5DE8-EBC2-470F-9757-C5F56089836B.png",
  figuranteTent:  "https://customer-assets.emergentagent.com/job_pagina-web-51/artifacts/djqi0009_IMG_3026.jpeg",
  raiserHug:      "https://customer-assets.emergentagent.com/job_pagina-web-51/artifacts/f5wkka2k_IMG_3036.jpeg",
  obedienceWalk:  "https://customer-assets.emergentagent.com/job_pagina-web-51/artifacts/00eedvmb_IMG_3034.jpeg",
  pastorBlack:    "https://customer-assets.emergentagent.com/job_pagina-web-51/artifacts/nybrd355_IMG_0916.jpeg",
  // Official PDF matrices (download only — we do NOT embed pages because they contain third-party logos)
  matrizMalinois: "https://customer-assets.emergentagent.com/job_pagina-web-51/artifacts/v8tyq7xi_MATRIZ%20DE%20CRIANZA%20DEL%20RSV2000%20malinois.pdf",
  matrizGSD:      "https://customer-assets.emergentagent.com/job_pagina-web-51/artifacts/mcfiqdmh_MATRIZ%20DE%20CRIANZA%20DEL%20RSV2000%20ovejero%20aleman.pdf",
};

// The 10 doctrinal articles (translated from RSV2000 official philosophy).
export const ARTICULOS = [
  {
    n: "01",
    titulo: "Herencia de von Stephanitz",
    texto: "El club se reconoce heredero del pensamiento del fundador Max von Stephanitz: el Pastor Alemán debe criarse como perro de utilidad polivalente.",
  },
  {
    n: "02",
    titulo: "Carácter de Trabajo Irrenunciable",
    texto: "Las propiedades definidas del perro de utilidad son irrenunciables y deben conservarse generación tras generación.",
  },
  {
    n: "03",
    titulo: "Armonía con el Entorno",
    texto: "Las tareas y objetivos de la crianza de trabajo deben armonizarse con las condiciones del entorno actual, sin renunciar a la esencia funcional.",
  },
  {
    n: "04",
    titulo: "Formación Continua",
    texto: "La capacitación permanente y la aplicación del progreso científico en métodos de cría y adiestramiento son condición y garantía para preservar al Pastor Alemán como perro de utilidad.",
  },
  {
    n: "05",
    titulo: "Pool Genético Amplio",
    texto: "Los instrumentos que dirigen la crianza deben agotar toda la amplitud del estándar. La amplitud del pool genético es el fundamento de la crianza y debe preservarse.",
  },
  {
    n: "06",
    titulo: "Documentación Transparente",
    texto: "Toda medida de selección requiere la documentación transparente y la objetivación de las propiedades individuales del ejemplar como perro de utilidad.",
  },
  {
    n: "07",
    titulo: "Diálogo entre Pares",
    texto: "El potencial creativo de los intereses concurrentes sirve al objetivo común. La aceptación mutua exige estructuras de comunicación que permitan reconocer y resolver los problemas.",
  },
  {
    n: "08",
    titulo: "Demostración en Competencia",
    texto: "La posición del Pastor Alemán como perro de utilidad debe demostrarse en la prueba — en el campeonato mundial del club (RSV WM) y en las competencias regionales.",
  },
  {
    n: "09",
    titulo: "Reconocimiento del Conductor",
    texto: "El trabajo del conductor del perro se valora conforme a su significado para la preservación del patrimonio cultural que es el Pastor Alemán.",
  },
  {
    n: "10",
    titulo: "Adiestramiento como Bienestar",
    texto: "El adiestramiento es bienestar animal practicado: se orienta a la funcionalidad del perro y a los principios éticos del trato humano hacia el animal.",
  },
];

// Five pillars of the breeding evaluation (Plan de Crianza).
export const PILARES = [
  {
    n: "I",
    titulo: "Anatomía Funcional",
    texto: "Estudio de la estructura ósea, angulaciones, movimiento y proporciones bajo el criterio de funcionalidad. El cuerpo debe servir al trabajo — no a la estética del ring.",
  },
  {
    n: "II",
    titulo: "Adaptabilidad Social",
    texto: "Evaluación de la capacidad del ejemplar para integrarse en entornos urbanos, sonoros y multitudinarios sin pérdida de control ni reactividad inapropiada.",
  },
  {
    n: "III",
    titulo: "Temperamento",
    texto: "Umbrales de estímulo, seguridad propia, capacidad de recuperación y firmeza bajo presión. El temperamento define el techo del perro.",
  },
  {
    n: "IV",
    titulo: "Instintos",
    texto: "Presa, defensa, lucha y rastro. Los instintos son la materia prima genética: deben estar presentes, ser estables y heredables.",
  },
  {
    n: "V",
    titulo: "Capacidad de Trabajo",
    texto: "Resistencia mental y física, claridad bajo carga, willingness para el trabajo prolongado y aprendizaje. Pruebas oficiales BH / IGP / SchH.",
  },
];

export const VALORES = ["Disciplina", "Trabajo", "Lealtad", "Excelencia", "Unión", "Pasión"];

// Camadas — Available litters. Presented institutionally, not commercially.
export const CAMADAS = [
  {
    id: "camada-latidos-montana",
    codigo: "CAM-2026-02",
    titulo: "Arrak × Working Dog Olympia",
    subtitulo: "Latidos de la Montaña · Cruce planificado · Francia × Alemania",
    lema: "Más que una camada, un legado en construcción.",
    estado: "Reservas abiertas",
    composite: "https://customer-assets-lqy194kg.emergentagent.net/job_pagina-web-51/artifacts/dpjjj4qi_arrakyolimpia.jpeg",
    padres: [
      {
        nombre: "Arrak von der Goetterbrucke",
        origen: "Francia · LOF 1 B.BEL 372708",
        criador: "Philippe Fuhs · Afijo von der Goetterbrucke",
      },
      {
        nombre: "Working Dog Olympia",
        origen: "Alemania · VDH/DMC 21/0223 · BH/VT · HD-A1 · ED-0 · LTV-0",
        criador: "Mathias Dögel · Talentsichtung RSV2000 950/930",
      },
    ],
    condiciones: [
      "Camada limitada — reserva anticipada",
      "Entrevista previa con la directiva",
      "Firma de contrato de colocación",
      "Sólo destino de trabajo — no mascota",
      "Genética europea documentada · trazabilidad FCI / VDH / DMC / Centrale Canine",
    ],
  },
  {
    id: "camada-roxi-nitro",
    codigo: "CAM-2026-01",
    titulo: "Roxi × Nitro",
    subtitulo: "Cruce planificado · Líneas policiales Francia · Holanda · Bélgica",
    estado: "Reserva abierta",
    parents: [
      {
        rol: "Madre",
        nombre: "Roxi",
        subtitulo: "Hija de Néron × Rouse",
        origen: "Francia · Holanda",
        raza: "Pastor Belga Malinois",
        lema: "Más que un origen, una base para el futuro.",
        infografia: "https://customer-assets-lqy194kg.emergentagent.net/job_pagina-web-51/artifacts/atelut41_image.png",
      },
      {
        rol: "Padre",
        nombre: "Nitro de Solare's Venezuela",
        subtitulo: "Criado en Francia · Genética francesa, mentalidad de trabajo",
        origen: "Francia (SCC / FCI · LOE / LOF)",
        raza: "Pastor Belga Malinois",
        lema: "Disciplina hoy, mejores resultados mañana.",
        infografia: "https://customer-assets-lqy194kg.emergentagent.net/job_pagina-web-51/artifacts/sxdsia21_nitro.jpeg",
      },
    ],
    condiciones: [
      "Reserva anticipada obligatoria",
      "Entrevista previa con la directiva",
      "Firma de contrato de colocación",
      "Sólo destino de trabajo — no mascota",
      "Líneas policiales exclusivas · sin excepciones",
    ],
  },
];

// LAZ — Landesausbildungswart · Definition + Responsibilities (from official infographic).
export const LAZ_INFO = {
  acronimo: "LAZ",
  alemania: "Landesausbildungswart",
  definicion: "El Landesausbildungswart (LAZ) es la máxima autoridad técnica de formación y deporte dentro de una región o país afiliado al RSV Global / RSV2000 Alemania.",
  significado: "Ser LAZ implica liderar, supervisar y garantizar el desarrollo técnico y deportivo de los clubes afiliados, asegurando el cumplimiento de los reglamentos y promoviendo la formación continua de guías, entrenadores, jueces y figurantes bajo los estándares internacionales de RSV Global y RSV2000 Alemania.",
  titular: "Frank Bergher Veintimilla",
  jurisdiccion: "RSV Global Guayaquil — Ecuador",
};

export const LAZ_RESPONSABILIDADES = [
  {
    n: "I",
    icon: "shield",
    titulo: "Supervisión Técnica Deportiva",
    texto: "Supervisar la correcta aplicación de los reglamentos deportivos y de entrenamiento en todos los clubes afiliados.",
  },
  {
    n: "II",
    icon: "users",
    titulo: "Formación y Capacitación",
    texto: "Coordinar y promover la formación técnica de guías, entrenadores, jueces y figurantes.",
  },
  {
    n: "III",
    icon: "gavel",
    titulo: "Evaluación y Apelaciones",
    texto: "Resolver apelaciones o reclamos relacionados con evaluaciones deportivas y pruebas oficiales, en coordinación con la directiva de RSV Global.",
  },
  {
    n: "IV",
    icon: "award",
    titulo: "Desarrollo de Clubes",
    texto: "Velar por el nivel técnico de los clubes afiliados y fomentar su crecimiento deportivo.",
  },
  {
    n: "V",
    icon: "presentation",
    titulo: "Programas y Seminarios",
    texto: "Promover seminarios, capacitaciones y programas de desarrollo deportivo en la región.",
  },
  {
    n: "VI",
    icon: "globe",
    titulo: "Enlace Institucional",
    texto: "Actuar como enlace técnico entre los clubes locales y la estructura superior de RSV Global / RSV2000 Alemania.",
  },
];

export const RAZAS = [
  {
    nombre: "Pastor Alemán",
    sub: "Línea de Trabajo · Deutscher Schäferhund (Gebrauchshund)",
    descripcion: "Bien cultural cinotécnico alemán. Selección estricta por funcionalidad: equilibrio entre nervio y carácter, claridad de impulsos, anatomía que sostiene la jornada de trabajo. Fundación doctrinal de Max von Stephanitz, continuidad institucional bajo el RSV2000 y aplicación cooperativa por el RSVglobal.",
    rasgos: ["BH / IGP / SchH", "Línea de trabajo", "Pool genético amplio", "Función sobre belleza"],
    img: ASSETS.obedienceWalk,
  },
  {
    nombre: "Pastor Belga Malinois",
    sub: "Belgischer Schäferhund — Malinois",
    descripcion: "Incorporado al plan de crianza desde 2022. Velocidad, intensidad de presa y ductilidad para el adiestramiento de alto rendimiento. Su evaluación se rige por idénticos criterios funcionales: temperamento estable, instintos limpios, capacidad de trabajo demostrable y aptitud para la jornada de servicio.",
    rasgos: ["Alta drive", "Trabajo policial / militar", "Schutzhund", "Mondioring / Ring"],
    img: ASSETS.marlonAction,
  },
];

export const GALERIA = [
  {
    src: "https://customer-assets.emergentagent.com/job_pagina-web-51/artifacts/uhifjdhu_475F4712-EA35-4410-92B0-3CF710354E0C.png",
    alt: "Schutzhund 1 — sección A",
    objectPosition: "center top",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_pagina-web-51/artifacts/uhifjdhu_475F4712-EA35-4410-92B0-3CF710354E0C.png",
    alt: "Obediencia con malinois",
    objectPosition: "center bottom",
  },
  { src: ASSETS.marlonAction,   alt: "Heeling con malinois" },
  { src: ASSETS.figuranteTent,  alt: "Trabajo de protección" },
  { src: ASSETS.raiserHug,      alt: "Tras la prueba" },
  { src: ASSETS.obedienceWalk,  alt: "Heeling con pastor alemán" },
];

export const CLUB_INFO = {
  nombreCompleto: "RSV Global Guayaquil",
  pais: "Ecuador",
  subtitulo: "Club Deportivo de Trabajo y Utilidad Canina",
  lema: "Disciplina · Pasión · Resultados",
  filialDe: "Filial cooperativa de RSVglobal e.V. / RSV2000 — Alemania",
  fundacionMatriz: "23 de junio de 2007 · Dr. Helmut Raiser",
  whatsapp: "+593 98 693 3570",
  whatsappLink: "https://wa.me/593986933570",
  ciudad: "Guayaquil, Ecuador",
  parentUrl: "https://www.rsv2000.de/",
  globalUrl: "https://www.rsvglobal.live/",
  registro: "Schäferhundverein RSVglobal e.V. · VR 201744 Amtsgericht Göttingen",
};

// Phases of the official RSV2000 breeding evaluation matrix (Handbook LCC — Ed. 2024).
// Source: official PDF documents provided by the club. We only present the STRUCTURE here;
// the complete matrices are available as official PDF downloads.
export const FASES_MATRIZ = [
  {
    n: "01",
    fase: "Avistamiento de Cachorros",
    edad: "4 – 6 meses",
    items: ["Presentación en entorno social", "Conducción y predisposición", "Comportamiento de presa", "Descripción anatómica básica"],
  },
  {
    n: "02",
    fase: "Avistamiento de Jóvenes",
    edad: "7 – 12 meses",
    items: ["Estabilidad mental", "Vínculo con el guía", "Conducta de cobro", "Primeras mordidas y agarre"],
  },
  {
    n: "03",
    fase: "Avistamiento de Talentos",
    edad: "≥ 12 meses",
    items: ["Drives consolidados", "Canalización", "Dominancia en mordida", "Conducta bajo presión"],
  },
  {
    n: "04",
    fase: "Anatomía Funcional",
    edad: "Confirmación",
    items: ["Apariencia general", "Estructura ósea", "Proporciones", "Aplomos y movimiento"],
  },
  {
    n: "05",
    fase: "Locomoción",
    edad: "Evaluación dinámica",
    items: ["Trote", "Galope", "Eficiencia del paso", "Coordinación"],
  },
  {
    n: "06",
    fase: "Körung 1 – 3",
    edad: "Selección de aptos de cría",
    items: ["Mediciones oficiales", "Evaluación temperamental", "Servicio de protección", "Confirmación final del apto"],
  },
];

// Evaluation criteria families (used in scoring 1/3/5 across all phases).
export const CRITERIOS = [
  { titulo: "Habilidades Mentales",   detalle: "Presentación social · vínculo con guía · neutralidad ante extraños · estabilidad" },
  { titulo: "Conducta de Trabajo",    detalle: "Conducción · predisposición a la obediencia · cobro · canalización" },
  { titulo: "Drives e Instintos",     detalle: "Presa · defensa · lucha · rastro · agarre · canalización" },
  { titulo: "Anatomía Funcional",     detalle: "Estructura · angulaciones · proporciones · aplomos · pelaje · dentición" },
  { titulo: "Locomoción",             detalle: "Trote eficiente · galope · coordinación · resistencia" },
  { titulo: "Salud y Sanidad",        detalle: "Test de disparo · testículos · ausencia de defectos eliminatorios" },
];
